import React from 'react';
import { string, shape, arrayOf } from 'prop-types';

import { ProductsTableHead, ProductsTableProduct } from './components';

import {isEcowise} from '../../utils'

const ProductsTable = ({ items, localization }) => {
    if (!items || !items.length) {
        return null;
    }

    return (
        <table>
            <ProductsTableHead localization={localization} />
            <tbody>
                {items.map(item => (
                    <ProductsTableProduct
                        {...item}
                        isEcowise={isEcowise(
                            item.filterOptions
                        )}
                        key={item.id}
                        localization={localization}
                    />
                ))}
            </tbody>
        </table>
    );
};

ProductsTable.propTypes = {
    items: arrayOf(shape({})),
    localization: shape({
        nameColTitle: string,
        groupColTitle: string,
        descriptionColTitle: string
    }).isRequired
};

export default ProductsTable;
